<template>
  <div
    v-if="!canView"
    class="permission-gate permission-gate--blocked"
  >
    <el-alert
      type="error"
      show-icon
      :closable="false"
      title="Acceso restringido"
      :description="blockedMessage"
    />
    <div class="permission-gate__actions">
      <el-button
        size="default"
        @click="goBack"
        >Volver</el-button
      >
      <el-button
        type="primary"
        size="default"
        @click="goHome"
        >Ir al inicio</el-button
      >
    </div>
  </div>

  <template v-else>
    <el-alert
      v-if="showNoEditAlert && !canEdit"
      type="error"
      show-icon
      :closable="false"
      title="El usuario no posee permisos de edición"
      class="permission-gate__noedit"
    />

    <slot
      :canView="canView"
      :canEdit="canEdit"
    />
  </template>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/views/auth/auth_store';
import {
  canViewModule,
  canEditModule,
} from '@/shared/permissions/permission.utils.js';

const props = defineProps({
  moduleKey: { type: String, required: true },
  blockedMessage: {
    type: String,
    default: 'El usuario no posee permisos para visualizar este módulo.',
  },
  showNoEditAlert: { type: Boolean, default: false },
});

const router = useRouter();
const authStore = useAuthStore();

const canView = computed(() => {
  const user = authStore.usuario();
  return canViewModule(user, props.moduleKey);
});

const canEdit = computed(() => {
  const user = authStore.usuario();
  return canEditModule(user, props.moduleKey);
});

const goBack = () => router.go(-1);
const goHome = () => router.push('/dashboard');
</script>

<style scoped>
.permission-gate--blocked {
  padding: 12px;
}
.permission-gate__actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}
.permission-gate__noedit {
  margin-bottom: 12px;
}
</style>
